import * as React from 'react';

/**
 * Context to indicate if head updates should be enabled/disabled.
 */
export const HeadEnabledContext = React.createContext(true);
